import React, { useEffect, useState } from "react";
// import { useSelector } from "react-redux";

import { getReactionUserName } from "../Helpers/chatCommon";
import { alertMsg } from "../util/alertMsg";
import { useSelector } from "react-redux";

const ReactionUserPopOver = (props) => {
  const { selectedReactionUser: reactionViaRedux } = useSelector(
    (state) => state.chat,
  );
  const selectedReactionUser = props.selectedReactionUser || reactionViaRedux;
  const [userNameData, setUserNameData] = useState([]);

  // useEffect(() => {
  //   const res = getReactionUserName(selectedReactionUser?.reactionUserId);
  //   setUserNameData(res);
  // }, [selectedReactionUser]);
  useEffect(() => {
    if (!selectedReactionUser?.reactionUserId) return;

    let isMounted = true;

    const fetchUserName = async () => {
      const res = await getReactionUserName(
        selectedReactionUser.reactionUserId,
      );

      if (isMounted) {
        setUserNameData(res);
      }
    };

    fetchUserName();

    return () => {
      isMounted = false;
    };
  }, [selectedReactionUser]);

  return (
    <>
      <div className="reactions-popup-container">
        <div className="reactions-popup">
          <div className="d-flex flex-column text-center align-items-center">
            {userNameData?.length > 0 ? (
              <>
                <div className="reactions-icon">
                  {selectedReactionUser?.emoji}
                </div>
                <div className="reactions-username">
                  {userNameData?.join(", ")}{" "}
                  {selectedReactionUser?.names?.length > 0 ? (
                    <b className="reactions-name">
                      &nbsp;
                      {`reacted with :${
                        selectedReactionUser.names.length > 1
                          ? selectedReactionUser.names[1]
                          : selectedReactionUser.names[0]
                      }:`}{" "}
                    </b>
                  ) : null}
                </div>
              </>
            ) : (
              alertMsg.loader
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default ReactionUserPopOver;
